import countryService from './services/countryService';

const urlMappings = {
  local: {
    api: 'http://local.vacanted.com.{countryCode}:8080',
    app: 'http://local.vacanted.com.{countryCode}:3000',
  },
  development: {
    api: 'https://develop.vacanted.com.{countryCode}/api',
    app: 'https://develop.vacanted.com.{countryCode}',
  },
  qa: {
    api: 'https://qa.vacanted.com.{countryCode}/api',
    app: 'https://qa.vacanted.com.{countryCode}',
  },
  production: {
    api: 'https://vacanted.com.{countryCode}/api',
    app: 'https://vacanted.com.{countryCode}',
  },
};

const vacantedEnvironment = process.env.REACT_APP_VACANTED_ENV || 'local';

if (!urlMappings[vacantedEnvironment]) {
  throw new Error(`Env ${vacantedEnvironment} is not valid to initialize app`);
}

export const getUrl = (component) => {
  const detectedCountryCode = countryService.getCurrentCountryCode();
  const urlTemplate = urlMappings[vacantedEnvironment][component];
  const url = urlTemplate.replace('{countryCode}', detectedCountryCode);
  return url;
};
